export default ({ route }) => {
  if (process.client && window?.analytics) {
    window.analytics.page(route.fullPath)
  }
}
